import { z } from 'zod';
import { UserSchema } from '../../entities/user/user.schema';
/**
 * Send Org Member Invitation Request Schema
 * POST /api/v2/org-members/:id/send-invitation
 *
 * No request body needed - user ID comes from URL params
 */ export const SendOrgMemberInvitationRequestSchema = z.object({});
/**
 * Send Org Member Invitation Response Schema
 * POST /api/v2/org-members/:id/send-invitation
 */ export const SendOrgMemberInvitationResponseSchema = z.object({
    data: UserSchema
});

//# sourceMappingURL=send-org-member-invitation.schema.js.map